// extracted by mini-css-extract-plugin
export default {"audienceComponentContainer":"AudienceContainer_audienceComponentContainer__hs-E8","scrollHideAudience":"AudienceContainer_scrollHideAudience__grZz-"};